"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
.Header {
  width: 100vw;
  height: 107px;
  background-color: var(--neutral-black);
}

@media screen and (max-width: 480px) {
  .Header {
    width: 100vw;
    height: 65px;
    background-color: var(--neutral-black);
  }
}

.SS-Logo {
  width: 193px;
  height: 38px;
  margin-left: 66.4px;
  margin-top: 35px;
  margin-bottom: 34px;
  object-fit: contain;
}

@media (min-width: 481px) and (max-width: 835px) {
  .SS-Logo {
    width: 173.7px;
    height: 33px;
    margin-left: 32.4px;
    margin-top: 35px;
    margin-bottom: 43px;
    object-fit: contain;
  }
}

@media screen and (max-width: 480px) {
  .SS-Logo {
    width: 118px;
    height: 24px;
    margin-left: 16.4px;
    margin-top: 23px;
    margin-bottom: 19px;
    object-fit: contain;
  }
}

.Captcha-container {
  margin-left: 34%;
  margin-top: 2rem;
}

@media (min-width: 481px) and (max-width: 835px) {
  .Captcha-container {
    margin-left: 22.9%;
    margin-top: 2rem;
  }
}

@media screen and (max-width: 480px) {
  .Captcha-container {
    margin-left: 8.5%;
    margin-right: 8.5%;
    margin-top: 2rem;
  }
}

.Pardon-the-interrupt {
  width: auto; max-height: 72px; margin: 0 34px 24px 0;
  font-family: SimpliSans;
  font-size: 36px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  color: var(--colors-neutral-black-2);
}

@media (min-width: 481px) and (max-width: 835px) {
  .Pardon-the-interrupt {
    width: auto; 
    max-height: 72px;
    height: 44px; 
    margin: 0 34px 24px 0;
    font-family: SimpliSans;
    font-size: 36px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    color: var(--colors-neutral-black-2);
  }
}

@media screen and (max-width: 480px) {
  .Pardon-the-interrupt {
    width: auto; max-height: 72px; margin: 0 0 16px;
    font-family: SimpliSans;
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: var(--colors-neutral-black-2);
  }
}

.We-know-youre-proba {
  width: auto;
  max-width: 453px;
  max-height: 84px;
  margin: 24px 0 32px;
  font-family: SimpliSans;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  color: var(--colors-neutral-black-2);
}

@media screen and (max-width: 480px) {
  .We-know-youre-proba {
    width: auto;
    max-width: 453px;
    max-height: 84px;
    margin: 16px 0 32px;
    font-family: SimpliSans;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    color: var(--colors-neutral-black-2);
  }
}

.Why-am-I-seeing-this {
  width: auto;
  height: 100px;
  margin: 24px 0 0;
  font-family: SimpliSans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: var(--colors-neutral-black-2);
}

@media screen and (max-width: 480px) {
  .Why-am-I-seeing-this {
    width: auto;
    height: 129px;
    margin: 24px 0 0;
    font-family: SimpliSans;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    color: var(--colors-neutral-black-2);
  }
}

.Why-am-I-seeing-this .text-style-1 {
  font-weight: 500;
}

.Why-am-I-seeing-this .text-style-2 {
  font-weight: 500;
  color: var(--colors-brand-primary-2);
}

`;
//# sourceMappingURL=style.js.map